import { render, staticRenderFns } from "./messagecontent.vue?vue&type=template&id=c1ef3dee"
import script from "./messagecontent.vue?vue&type=script&lang=js"
export * from "./messagecontent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports